import { useState, useEffect } from 'react'
import {
  onAuthStateChanged,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut as firebaseSignOut,
  GoogleAuthProvider,
  type User,
  type UserCredential,
} from 'firebase/auth'
import { auth } from '../lib/firebase.js'

const googleProvider = new GoogleAuthProvider()

export interface AuthState {
  user:          User | null
  loading:       boolean
  signInGoogle:  () => Promise<UserCredential>
  signInEmail:   (email: string, password: string) => Promise<UserCredential>
  signUpEmail:   (email: string, password: string) => Promise<UserCredential>
  signOut:       () => Promise<void>
}

export function useAuth(): AuthState {
  const [user,    setUser]    = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    return onAuthStateChanged(auth, (u) => {
      setUser(u)
      setLoading(false)
    })
  }, [])

  return {
    user,
    loading,
    signInGoogle: () => signInWithPopup(auth, googleProvider),
    signInEmail:  (email, password) => signInWithEmailAndPassword(auth, email, password),
    signUpEmail:  (email, password) => createUserWithEmailAndPassword(auth, email, password),
    signOut: async () => {
      await firebaseSignOut(auth)
    },
  }
}
